const DEFAULT_WORK_WEEK = [1, 2, 3, 4, 5];
const DEFAULT_WORK_DAY = [
  "8 AM",
  "9 AM",
  "10 AM",
  "11 AM",
  "12 PM",
  "1 PM",
  "2 PM",
  "3 PM",
  "4 PM",
];
const DEFAULT_HOURS_PER_DAY = 8;

const asNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export const resolveBusinessHoursSchedule = (source = {}, fallback = {}) => {
  const schedule = source.businessHoursSchedule || source.data?.businessHoursSchedule || {};
  const fallbackWorkDay = fallback.workDay || DEFAULT_WORK_DAY;
  const hoursPerDay =
    asNumber(schedule.hoursPerDay) ??
    asNumber(source.businessHoursHoursPerDay) ??
    asNumber(fallback.hoursPerDay) ??
    DEFAULT_HOURS_PER_DAY;

  return {
    businessHours: schedule.businessHours || source.businessHours || [],
    businessHoursCreated: schedule.businessHoursCreated || source.businessHoursCreated,
    workWeek: Array.isArray(schedule.workWeek)
      ? schedule.workWeek
      : fallback.workWeek || DEFAULT_WORK_WEEK,
    workDay: Array.isArray(schedule.workDay) ? schedule.workDay : fallbackWorkDay,
    hoursPerDay,
    startHour:
      asNumber(schedule.startHour) ??
      asNumber(fallback.startHour) ??
      Number.parseInt(fallbackWorkDay[0], 10),
    endHour:
      asNumber(schedule.endHour) ??
      asNumber(fallback.endHour) ??
      Number.parseInt(fallbackWorkDay[fallbackWorkDay.length - 1], 10) + 1,
  };
};
